'use client';

import type { CSSProperties } from 'react';
import { useMarketingBannerOffset } from 'components/shared/Header/MarketingBanner';
import { useTranslations } from 'next-intl';
import HeroSciencesBackground from '../HeroSciencesBackground';
import MeshFlow from '../home/MeshFlow';
import SearchTrigger from './SearchTrigger';
import styles from './HeroSection.module.css';

interface Props {
  onOpenSearch: () => void;
  searchOpen?: boolean;
  searchPanelId?: string;
}

const HeroSection = ({ onOpenSearch, searchOpen, searchPanelId }: Props) => {
  const t = useTranslations('science');
  const bannerPx = useMarketingBannerOffset();
  return (
    <div
      className={styles.frame}
      style={{ '--banner-px': `${bannerPx}px` } as CSSProperties}
    >
      <section className={styles.wrap}>
        {/* SVG stays under the WebGL layer so the previous design shows if
            the shader fails. */}
        <div className={styles.bg} aria-hidden="true">
          <HeroSciencesBackground />
        </div>
        <div className={styles.flow} aria-hidden="true">
          <MeshFlow />
        </div>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('science.hero.title')}</h1>
          <p className={styles.lede}>{t('science.hero.lede')}</p>
          <div className={styles.searchSlot}>
            <SearchTrigger
              onClick={onOpenSearch}
              expanded={searchOpen}
              controls={searchPanelId}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
